import MuiInput from "./MuiInput";
import MuiButton from "./MuiButton";

/** Slim Formik control router — only controls in active use are kept. */
function FormikControl({ control, ...rest }) {
  switch (control) {
    case "textfield": return <MuiInput  {...rest} />;
    case "button":    return <MuiButton {...rest} />;
    default:          return null;
  }
}

export default FormikControl;
